module.exports = __webpack_public_path__ + "static/media/ERUPT_2017_pic.d90bbfac.jpg";